<template>
    <div class="block-box">
        <div class="block-item">
            <el-col :span="6" class="label">
                {{configData.title}}
            </el-col>
            <el-slider :span="18" class="slider-box" v-model="configData.val" :min="configData.min" show-input :show-input-controls="false"></el-slider>
        </div>
    </div>
</template>

<script>
    export default {
        name: "slide",
        props: {
            configData: {
                type: Object,
                default: {}
            },
        },
    }
</script>

<style scoped>

</style>
